<div class="container">
  <rd-shared-icon
    [iconSymbol]="'icon-linked'"
    [iconTheme]="'success'"></rd-shared-icon>

  <h1 class="title">
    {{ 'redeem_cash_v2.membership_success_dialog.title' | translate }}
  </h1>

  <p class="description">
    {{ 'redeem_cash_v2.membership_success_dialog.description' | translate }}
  </p>

  <div class="buttons-wrapper">
    <rd-shared-button
      class="ok-button"
      [buttonClass]="successLinkedDialogButton.buttonClass"
      [buttonContent]="okButtonContent"
      [buttonTheme]="successLinkedDialogButton.buttonTheme"
      (clickFn)="closeDialog()">
      <ng-template #okButtonContent>
        <span class="ok-button-text">{{
          successLinkedDialogButton.buttonText | translate
        }}</span>
      </ng-template>
    </rd-shared-button>
  </div>
</div>
